import React from 'react';

import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
        borderStyle: 'solid'
    }
}));

function AutocompleteBordered<
    T,
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined
>(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
    const classes = useStyles();
    return (
        <Autocomplete
            {...props}
            classes={{
                paper: classes.paper
            }}
        />
    );
}

export default AutocompleteBordered;
